var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsActivityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92871 11.8828H18.0394V13.521H7.92871V11.8828Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92871 15.8516H18.0394V17.4896H7.92871V15.8516Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 8.28418C29 5.37053 26.6296 3 23.716 3C21.5762 3 19.7291 4.27849 18.8992 6.11172H4.26501C2.46477 6.11172 1 7.57666 1 9.37673V19.8605C1 21.6609 2.46477 23.1259 4.26501 23.1259H5.14856V27.8153L12.153 23.1259H21.2723C23.0729 23.1259 24.5377 21.6609 24.5377 19.8605V13.5043C27.0622 13.1083 29 10.9182 29 8.28418ZM21.2723 21.4875H11.6553L6.78662 24.747V21.4875H4.26501C3.36797 21.4875 2.63806 20.7577 2.63806 19.8605V9.37673C2.63806 8.47986 3.36797 7.75012 4.26501 7.75012H18.4588C18.441 7.92563 18.4318 8.10388 18.4318 8.28418C18.4318 10.9199 20.372 13.1114 22.8993 13.5051V19.8605C22.8993 20.7577 22.1694 21.4875 21.2723 21.4875ZM23.716 11.93C21.7057 11.93 20.0702 10.2945 20.0702 8.28418C20.0702 6.27373 21.7057 4.63806 23.716 4.63806C25.7263 4.63806 27.3619 6.27373 27.3619 8.28418C27.3619 10.2945 25.7263 11.93 23.716 11.93Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8965 6.3457H24.5347V10.2227H22.8965V6.3457Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsActivityIcon);
export default __webpack_public_path__ + "static/media/SMSActivityIcon.0f72e4410866098bb915689702b8ac63.svg";
export { ForwardRef as ReactComponent };